import React from "react";
import { Player, ControlBar, PlayToggle } from "video-react";
import "../../../node_modules/video-react/dist/video-react.css";
import autoBind from "react-autobind";
import {
	Button
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import { itemHasVideo, itemHasImage, itemHasPdf, handleOpenInNewTab } from "../../utils/utils";
import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId } from "../../actions/playerActions";

// import { getConfigParam } from "../../utils/config";

const hoc = (WrappedComponent) => {
	class PlayerItemHoc extends React.PureComponent {

		constructor(props) {
			super(props);
			autoBind(this);
			this.state = {
				readInline: {}
			}
		}

		getActivityItemPath(delimiter) {
			const { listIndex, sectionIndex, itemIndex } = this.props;
			return listIndex + delimiter + sectionIndex + delimiter + itemIndex;
		}

		handleReadInline() {
			const item = this.props.item;
			const { guid } = item;
			if (guid) {
				const readInline = _.clone(this.state.readInline);
				readInline[guid] = true;
				this.setState({ readInline });
			}
		}

		getImage() {
			const item = this.props.item;

			let image;
			let imgUrl;

			// const webMode = getConfigParam("webMode", false);

			if (itemHasImage(item)) {
				const url = getUrlForValue(item.image, getSelectedActivityId());
				imgUrl = "<a href='" + url + "' target='blank'><img style='width: 400px; max-width: 100% ' src='" + url + "' /></a>";

				image =
					<div>
						<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
							<div dangerouslySetInnerHTML={markdownToHtml(imgUrl)} />
						</div>
						{/* !webMode && <Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesome name="external-link" /> View In New Tab</Button> */}
					</div>;
			}
			return image;
		}

		getImageShowMode() {
			const item = this.props.item;

			let image;

			if (itemHasImage(item)) {
				const url = getUrlForValue(item.image, getSelectedActivityId());
				image = <img alt="Show Mode" className="player-show-mode-image" src={url} onClick={() => { this.onClickShowModeImage(url); }} />;
			}
			return image;
		}

		getVideo() {
			const item = this.props.item;

			let video;

			if (itemHasVideo(item)) {
				const url = getUrlForValue(item.video, getSelectedActivityId());
				video =
						<div style={{ width: 400, height: 300, maxWidth: "100%", maxHeight: "100%", padding: "3px", cursor: "pointer" }}>
							<Player
								playsInline
								src={url}
								fluid={false}
								width={"100%"}
								height={"100%"}
							/>
							{/* !webMode && <Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesome name="external-link" /> View In New Tab</Button> */}

						</div>;

			}

			return video;
		}

		getPdf() {
			const item = this.props.item;

			let pdf;

			if (itemHasPdf(item)) {
				const url = getUrlForValue(item.pdf, getSelectedActivityId());
				const showPdfActions = !this.state.readInline[item.guid];
				pdf =
					<div>
						<div className="embed-responsive embed-responsive-210by297-player">
							{showPdfActions && <div class="pdf-actions">
								<div>
									<Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={this.handleReadInline}><FontAwesome name="hand-o-down" /><br />Read Inline</Button><Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesome name="external-link" /><br />View In New Tab</Button>
								</div>
							</div>}
							<object className="embed-responsive-item" data={url} type="application/pdf" internalinstanceid="9" title="">
								<p>Your browser isn't supporting embedded pdf files. You can download the file
            				<a href={url}>here</a>.</p>
							</object>
						</div>
						{!showPdfActions && <Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesome name="external-link" /> View In New Tab</Button>}
					</div>;

			}

			return pdf;
		}

		getVideoShowMode(ref) {
			const item = this.props.item;

			let video;

			if (itemHasVideo(item)) {
				const url = getUrlForValue(item.video, getSelectedActivityId());
				video =
					<div style={{ width: "100%", height: "100%" }}>
						<Player
							playsInline
							src={url}
							fluid={false}
							width={"100%"}
							height={"100%"}
							ref={ref}>
							<ControlBar autoHide={false} disableDefaultControls={true}>
								<PlayToggle />
							</ControlBar>
						</Player>
					</div>;
			}

			return video;
		}


		onClickShowModeImage(url) {
			if (this.props.onClickShowModeImage) {
				this.props.onClickShowModeImage(url);
			}
		}

		getAcceptDefaultButton(defaultValueProp, onClickHandler) {
			const item = this.props.item;

			let component;

			//if we have a default value defined and component isn't completed we want to show this button if showAcceptDefaultButton=true
			if (this.props.showAcceptDefaultButton &&
				!_.isUndefined(item[defaultValueProp]) &&
				item[defaultValueProp] !== "" &&
				item.checked === false) {

				component = <div>
					<Button bsStyle="primary" onClick={onClickHandler}>Accept Default</Button>
				</div>;
			}

			return component;
		}

		getLabelStyles() {
			const { item } = this.props;
			const { resolvedStyles } = item;

			let itemStyle;
			let styleLabel1;
			let styleLabel2;

			if (!_.isUndefined(resolvedStyles)) {
				itemStyle = resolvedStyles.item;
				styleLabel1 = resolvedStyles.label1;
				styleLabel2 = resolvedStyles.label2;
			}

			if (item.checked) {
				const theme = window.activityTheme;
				styleLabel1 = _.assign({}, styleLabel1, theme.item.checked);
				styleLabel2 = _.assign({}, styleLabel2, theme.item.checked);
			}

			return {
				item: itemStyle,
				styleLabel1,
				styleLabel2
			}
		}

		render() {

			let wrappedComponent = <WrappedComponent
				getImage={this.getImage}
				getImageShowMode={this.getImageShowMode}
				getVideo={this.getVideo}
				getVideoShowMode={this.getVideoShowMode}
				getPdf={this.getPdf}
				getLabelStyles={this.getLabelStyles}
				getAcceptDefaultButton={this.getAcceptDefaultButton}
				getActivityItemPath={this.getActivityItemPath}
				{...this.props} />;


			return wrappedComponent;
		}
	}

	return PlayerItemHoc;
};

export default hoc;